import React from 'react';
import campusImages from './sportsData';
import "./sports.css";


function sports() {
  return (
  <>
 <div className='container'>
	  <div className="gallery__page">
		<div className="text-center wow fadeInUp" data-wow-delay="0.1s">
		  <h4 className="section-title bg-white text-center text-primary px-3">Gallery</h4>
		  <h4 className="mb-5">Sports & Event</h4>
		</div>
		<div className="gallery__warp">
		  <div className="row">
			{campusImages.map((img, index) => (
			  <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
				<a className="gallery__item fresco" href={img} data-fresco-group="gallery">
				  <img src={img} alt={`Campus ${index + 1}`} style={{ width: "100%", height: "100%" }} />
				</a>
			  </div>
			))}
		  </div>
		</div>
	  </div>
	</div>
  </>
  )
}

export default sports